// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__8vWJs","backButton":"styles_backButton__3BcI-","content":"styles_content__2liB9","actions":"styles_actions__2jU0T","button":"styles_button__2aF3X"};